// Line item properties marking a line as outside the standard return policy.
// Written at every add to cart, and read back by the cart to badge a final sale
// line.

const NON_RETURNABLE_TAG = "non-returnable";
const FINAL_SALE_TAG = "final-sale";

/**
 * @param {string[]} tags the product's tags
 * @returns {object} the properties those tags call for
 */
export default function returnPolicyProperties(tags = []) {
  return {
    ...(tags.includes(NON_RETURNABLE_TAG) && { _non_returnable: "true" }),
    ...(tags.includes(FINAL_SALE_TAG) && { _final_sale: "true" }),
  };
}

/**
 * The same properties for Liquid-rendered markup, which resolves the tags
 * itself via the `return-policy-attributes` snippet.
 *
 * @param {DOMStringMap|object} dataset element carrying the snippet's attributes
 * @returns {object}
 */
export function returnPolicyPropertiesFromDataset(dataset = {}) {
  return {
    ...(dataset.nonReturnable && { _non_returnable: "true" }),
    ...(dataset.finalSale && { _final_sale: "true" }),
  };
}
